<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div v-if="visible" class="modal-overlay" @click.self="close">
      <div class="custom-modal">
        <div class="modal-header">
          <h3>获取确认</h3>
          <button class="close-btn" @click="close">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        
        <div class="modal-body">
          <div class="tip-text">
            从本站获取工具代表您已经详细阅读并同意了我们的 <a class="link" @click.stop="openDisclaimer">《免责声明》</a> 和 <a class="link" @click.stop="openRules">《文章规则》</a> ，是否继续？
          </div>
          <div class="sub-tip">
            (登录后则不再弹出此对话框)
          </div>
        </div>
        
        <div class="modal-footer">
          <button class="cancel-btn" @click="close">取消</button>
          <button class="confirm-btn" @click="confirm">同意并继续</button>
        </div>
      </div>
    </div>
  </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'AgreementModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'confirm', 'open-disclaimer', 'open-rules'],
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    confirm() {
      this.$emit('confirm')
    },
    openDisclaimer() {
       // Assuming these routes exist or handled by parent. 
       // For better decoupling, emit events.
       this.$router.push('/disclaimer')
       this.close()
    },
    openRules() {
       this.$router.push('/rules')
       this.close()
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-dialog);

}

.custom-modal {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 80vh;
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-family: '猫啃网糖圆体';
  font-size: 1.2em;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 24px 20px;
  flex: 1;
  overflow-y: auto;
}

.tip-text {
  color: #666;
  font-size: 1em;
  line-height: 1.6;
  font-family: '爱点风雅黑';
}

.link {
  color: #409EFF;
  cursor: pointer;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.sub-tip {
  margin-top: 10px;
  color: #999;
  font-size: 0.9em;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn {
  padding: 8px 20px;
  border: none;
  background: #f5f5f5;
  color: #666;
  border-radius: 20px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.confirm-btn {
  padding: 8px 20px;
  border: none;
  background: linear-gradient(135deg, #409EFF 0%, #3a8ee6 100%);
  color: white;
  border-radius: 20px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* Dark Theme Support */
.dark-theme .custom-modal {
  background: #2d2d2d;
  color: #fff;
}

.dark-theme .modal-header {
  border-bottom-color: #3d3d3d;
}

.dark-theme .modal-header h3 {
  color: #fff;
}

.dark-theme .close-btn {
  color: #aaa;
}

.dark-theme .tip-text {
  color: #ccc;
}

.dark-theme .sub-tip {
  color: #888;
}

.dark-theme .link {
  color: #87ceeb;
}

.dark-theme .modal-footer {
  border-top-color: #3d3d3d;
}

.dark-theme .cancel-btn {
  background: #383838;
  color: #ccc;
}

.dark-theme .cancel-btn:hover {
  background: #444;
}

/* Animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .custom-modal {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-fade-leave-active .custom-modal {
  transition: transform 0.3s ease-in;
}

.modal-fade-enter-from .custom-modal {
  transform: scale(0.9) translateY(10px);
}

.modal-fade-leave-to .custom-modal {
  transform: scale(0.95) translateY(10px);
}

@media (max-width: 480px) {
  .custom-modal {
    width: 100%;
    border-radius: 20px 20px 0 0;
    position: absolute;
    bottom: 0;
    margin: 0;
    max-width: none;
    max-height: 90vh;
  }
  
  .modal-overlay {
    align-items: flex-end;
  }
  
  .modal-fade-enter-from .custom-modal,
  .modal-fade-leave-to .custom-modal {
    transform: translateY(100%);
  }
}
</style>
